const initialAssignmentsFilterState = {
  fetching: false,
  fetched: false,
  items: [],
  filteredItems: [],
  error: null,
  nbResult: 0,
};

export const getDocumentsToBeExportedEfffZip = (state = initialAssignmentsFilterState, action) => {
  switch (action.type) {
    case "GET_DOCUMENTS_TO_BE_EXPORTED_ZIP_EFFF_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "GET_DOCUMENTS_TO_BE_EXPORTED_ZIP_EFFF_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data : [],
        filteredItems: data ? data : [],
        nbResult: nbResult
      };
    }

    case "GET_DOCUMENTS_TO_BE_EXPORTED_ZIP_EFFF_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        filteredItems: [],
        nbResult: 0,
        error
      };
    }

    case "SET_FILTERED_DOCUMENTS_TO_BE_EXPORTED_EFFF_ITEMS" : {
      return {...state, filteredItems: action.payload};
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/statistics/getDocumentsToBeExportedEfffZip.js